import React from 'react';
import { PropTypes } from 'prop-types';
import Select from 'react-select';
import tailwindTheme from '../../../../../../config/tailwind.config';
import CustomClearIndicator from './ClearIndicator';

const AutocompleteText = ({
  label, value, onChange = () => {}, options, isMulti = false, inputId = undefined,
}) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: '2.5rem',
      height: '2.5rem',
      padding: '0 0.75rem',
      borderRadius: '0.375rem',
      borderColor: tailwindTheme.theme.extend.colors['vamos-blue-gray'],
      fontFamily: 'DM Sans',
      fontWeight: '400',
      backgroundColor: tailwindTheme.theme.extend.colors['vamos-white'],
      boxShadow: state.isFocused ? 'black' : null,
      '&:hover': {
        borderColor: 'black',
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: 0,
    }),
    dropdownIndicator: () => ({
      display: 'none',
    }),
    indicatorSeparator: () => {},
    option: () => ({
      padding: '5px 10px',
      display: 'flex',
      '&:hover': {
        backgroundColor: '#1867D2',
        cursor: 'default',
      },
    }),
    clearIndicator: (provided) => ({
      ...provided,
      color: tailwindTheme.theme.extend.colors['vamos-black'],
      padding: 0,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: tailwindTheme.theme.extend.colors['vamos-black'],
    }),
  };

  return (
    <div className="w-full">
      <h3 className="flex mb-1 text-vamos-black font-sans text-sm font-small">{label}</h3>
      <Select
        inputId={inputId}
        classNamePrefix="react-select"
        value={value}
        onChange={onChange}
        options={options}
        isSearchable
        isClearable
        isMulti={isMulti}
        styles={customStyles}
        className="bg-vamos-white focus:border-black w-full focus:ring-0 mb-1"
        placeholder=""
        components={{
          ClearIndicator: CustomClearIndicator,
          IndicatorSeparator: () => null,
        }}
      />
    </div>
  );
};

export default AutocompleteText;

AutocompleteText.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  isMulti: PropTypes.bool,
  inputId: PropTypes.string,
};
